export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9559.36a6fcb6.jpg";